import { onDomReady } from "../../components/dynamic/observer";
import { Swiper } from 'swiper';
import { Pagination } from 'swiper/modules';
import '../../../node_modules/swiper/swiper.scss';
import '../../../node_modules/swiper/modules/pagination.min.css';

// Обратите внимание - модули подрубаются отдельным импортом из swiper/modules

function init() {
    if (window.matchMedia("(min-width: 1200px)").matches) return;

    const container = document.querySelector('[data-how-to-connect-slider-container]');

    if (!container) return;

    const sliderElement = container.querySelector('[data-how-to-connect-slider]');
    if (!sliderElement) {
        return;
    }

    const pagination = container.querySelector('[data-how-to-connect-slider-pagination]');

    const slider = new Swiper(sliderElement, {
        modules: [Pagination],
        slidesPerView: 1.5,
        pagination: {
            el: pagination,
            type: 'bullets',
        },
        spaceBetween: 32
    });
}

onDomReady(init);